import { buildDefaultMatrixConfig } from '@/components/views/Matrix/classes/IMatrixConfig';
import { SettingsBase } from './SettingsBase';
import type IMatrixConfig from '@/components/views/Matrix/classes/IMatrixConfig';

type RaceID = number;
type StationRoles = number[];
type RaceGroupIDs = number[];
type CategoryIDs = number[];

type StationRolesMap = Map<RaceID, StationRoles>;
type RaceGroupMap = Map<RaceID, RaceGroupIDs>;
type CategoryMap = Map<RaceID, CategoryIDs>;

/**
 * The first version of the MatrixSettings
 * This is what is saved in the db as matrix settings.
 * This is obsolete now, and is only kept around for backwards compatibility with old saved settings
 */
export class SavedMatrixSettingsV1 extends SettingsBase {
    static NAME_OF_CLASS = 'SavedMatrixSettingsV1';
    public MatrixConfig: IMatrixConfig;

    public StationRolesMap: StationRolesMap;
    public RaceGroupMap: RaceGroupMap;
    public CategoryMap: CategoryMap;

    public constructor(val?: SavedMatrixSettingsV1) {
        super();

        this.StationRolesMap = new Map<RaceID, StationRoles>(val?.StationRolesMap);
        this.RaceGroupMap = new Map<RaceID, RaceGroupIDs>(val?.RaceGroupMap);
        this.CategoryMap = new Map<RaceID, CategoryIDs>(val?.CategoryMap);

        this.MatrixConfig = buildDefaultMatrixConfig(val?.MatrixConfig);

        // Reset the RaceID so we dont have a preselected race
        this.MatrixConfig.RaceID = null;

        // Reset search so we dont have a saved search
        this.MatrixConfig.SearchString = '';
    }

    public deserialize(json: any): any {
        return JSON.parse(json, (key, value) => {
            // If the key is one of the maps we need to convert the array back to a map
            if (['StationRolesMap', 'RaceGroupMap', 'CategoryMap'].includes(key)) {
                return new Map(value);
            }

            return value;
        });
    }
}
